module.exports = __webpack_public_path__ + "media/icons/pro-2945d778.svg";